// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "finance.soulswap.app",
    name: "SoulSwap",
    homepage: "https://app.soulswap.finance",
    image_id: "24fc6e6e-a276-4c95-fa77-91ec1097d600",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/soulwallet-defi-portal/id6469735252",
        android: null,
        mac: "https://apps.apple.com/us/app/soulwallet-defi-portal/id6469735252",
        windows: null,
        linux: null,
        chrome: "https://apps.apple.com/us/app/soulwallet-defi-portal/id6469735252",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "soulwallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map